<template>
  <div class="min-h-screen bg-white pb-[100px]" :class="{'pt-[50px]': !useAuthStore.isAuthenticated }">
    <div class="absolute inset-0 overflow-hidden">
      <div class="absolute -top-40 -right-40 w-80 h-80 bg-purple-100/50 rounded-full blur-3xl animate-pulse"></div>
      <div class="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-100/50 rounded-full blur-3xl animate-pulse delay-1000"></div>
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-indigo-100/30 rounded-full blur-3xl animate-pulse delay-500"></div>
    </div>

    <div class="relative z-10 pb-16 pt-7">
      <div style="background: url('/login-bg.webp'); background-repeat: no-repeat; background-size: 100%">
        <div class="mx-auto">
        <div class=" mb-12 animate-fade-in-up text-center  py-15">
          <h1 class=" text-2xl md:text-4xl font-bold mb-4 text-gray-900 px-4 sm:px-6 lg:px-8">
            Nos Forfaits pour le
            <br>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-primary-300 to-primary-600 px-4 sm:px-6 lg:px-8">
              {{ pageTitle }}
            </span>
          </h1>

          <p class=" text-gray-500 mx-auto mt-2 px-4 sm:px-6 lg:px-8">
            {{ pageDescription }}
          </p>
        </div>


        <div class="max-w-lg mx-auto mb-8 px-4 sm:px-6 lg:px-8">
          <div class="bg-white rounded-2xl p-4 border border-gray-200 shadow-xl">
            <div class="text-center mb-6">
              <div class="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-r from-primary-400 to-primary-500 rounded-full mb-3">
                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                </svg>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-2">Code Promo</h3>
              <p class="text-gray-600 text-sm">Profitez de réductions exclusives</p>
            </div>

            <div class="relative">
              <input
                v-model="promoCodeInput"
                type="text"
                placeholder="Entrez votre code promo"
                class="w-full px-6 py-4 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 outline-none transition-all duration-300 shadow-sm"
                @keyup.enter="applyPromoCode"
              />
              <button
                @click="applyPromoCode"
                :disabled="generalStore.isLoading || !promoCodeInput.trim() || !selectedExamType"
                class="absolute cursor-pointer right-2 top-1/2 transform -translate-y-1/2 px-6 py-2 bg-gradient-to-r from-primary-400 to-primary-600 text-white font-medium rounded-lg hover:from-purple-700 hover:to-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 hover:shadow-lg hover:scale-105"
              >
                <span v-if="generalStore.isLoading" class="flex items-center">
                  <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Chargement...
                </span>
                <span v-else>Appliquer</span>
              </button>
            </div>

            <div v-if="generalStore.codePromo && generalStore?.packages[0]?.reduction_percentage > 0" class="mt-4 p-3 bg-green-50 border border-green-200 rounded-xl">
              <div class="flex items-center text-green-700">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span class="text-sm font-medium">Code actif : {{ generalStore.codePromo }}</span>
              </div>
            </div>
            <div v-if="generalStore.codePromo && generalStore?.packages[0]?.reduction_percentage == 0" class="mt-4 p-3 bg-red-50 border border-red-200 rounded-xl">
              <div class="flex items-center text-red-700">
                <i class="fa-solid fa-close"></i>
                <span class="text-sm font-medium">Code invalide : {{ generalStore.codePromo }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="flex justify-center  px-4 sm:px-6 lg:px-8 flex-wrap gap-4 mb-8 animate-fade-in-up" style="animation-delay: 200ms;">
          <button
              v-for="exam in examTypes"
              :key="exam.slug"
              @click="handleExamTypeChange(exam)"
              :class="[
                  'px-6 py-3 font-semibold cursor-pointer rounded-full text-sm transition-all duration-300 transform hover:scale-105',
                  selectedExamType && selectedExamType.slug === exam.slug
                      ? 'bg-gradient-to-r from-primary-400 to-primary-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 hover:border-purple-300'
              ]"
          >
              {{ exam.name }}
          </button>
        </div>

        <LoadingState v-if="generalStore.isLoading"></LoadingState>


        <div v-else-if="error" class="max-w-md mx-auto mb-12 px-4 sm:px-6 lg:px-8">
          <div class="bg-red-50 border border-red-200 rounded-2xl p-6 shadow-lg">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <svg class="h-6 w-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <div class="ml-4 flex-1">
                <p class="text-red-800 font-medium">{{ error }}</p>
                <button
                  @click="loadPackages"
                  class="mt-3 text-sm text-red-600 hover:text-red-700 underline transition-colors"
                >
                  Réessayer
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="generalStore.packages && generalStore.packages.length" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-4 max-w-7xl sm:px-6 lg:px-8  gap-8 mx-auto">
          <div
            v-for="(pkg, index) in generalStore.packages"
            :key="pkg.slug"
            :class="`package-card transform transition-all duration-500 hover:scale-105 hover:-translate-y-4`"
            :style="`animation-delay: ${index * 100}ms`"
          >
            <div class="relative h-full bg-white rounded-3xl border border-gray-200 shadow-xl overflow-hidden group hover:shadow-2xl hover:border-purple-200 transition-all duration-500">
              <div v-if="pkg.promo_code && pkg.reduction_percentage > 0" class="absolute top-6 right-6 z-20">
                <div class="relative">
                  <div class="absolute inset-0 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-full blur animate-pulse"></div>
                  <div class="relative bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg transform rotate-12 hover:rotate-0 transition-transform duration-300">
                    -{{ pkg.reduction_percentage }}%
                  </div>
                </div>
              </div>

              <div class="absolute inset-0 bg-gradient-to-r from-purple-500/5 via-transparent to-primary-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div class="relative py-4 text-center bg-gray-50 border-b border-gray-200">

                <h3 class="text-2xl font-bold text-gray-900 mb-4 uppercase tracking-wide">{{ pkg.name }}</h3>

                <div class="">
                  <div v-if="pkg.promo_code && pkg.reduction_percentage > 0" class="text-gray-400 text-lg line-through mb-1">
                    {{ formatPrice(pkg.price) }} XAF
                  </div>
                  <div class="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-300 to-primary-600 ">
                    {{ formatPrice(pkg.promo_price || pkg.price) }}
                  </div>
                  <div class="text-gray-600 text-lg font-medium">
                    XAF / {{ pkg.period }} {{ pkg.period > 1 ? 'mois' : 'mois' }}
                  </div>
                </div>
              </div>

              <div class="px-8 pb-8">
                <div class="space-y-4 mb-8 pt-4">
                  <div class="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-100">
                    <div class="flex items-center">
                      <svg class="w-5 h-5 text-purple-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                      </svg>
                      <span class="text-gray-700 font-medium">Type d'examen</span>
                    </div>
                    <span class="font-bold text-gray-900 bg-gradient-to-r from-purple-50 to-blue-50 px-3 py-1 rounded-lg border border-purple-100">{{ pkg.exam_type }}</span>
                  </div>

                  <div class="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-100">
                    <div class="flex items-center">
                      <svg class="w-5 h-5 text-primary-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span class="text-gray-700 font-medium">Durée d'accès</span>
                    </div>
                    <span class="font-bold text-gray-900">{{ pkg.period }} mois</span>
                  </div>

                  <div v-if="pkg.promo_code && pkg?.reduction_percentage > 0" class="flex items-center justify-between p-4 bg-green-50 rounded-xl border border-green-200">
                    <div class="flex items-center">
                      <svg class="w-5 h-5 text-green-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                      </svg>
                      <span class="text-green-700 font-medium">Code promo</span>
                    </div>
                    <span class="font-bold text-green-700 bg-green-100 px-3 py-1 rounded-lg">
                      {{ pkg.promo_code }}
                    </span>
                  </div>

                  <div v-if="pkg.promo_code && pkg.reduction_percentage > 0" class="p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200">
                    <div class="flex items-center justify-between">
                      <span class="text-green-700 font-medium flex items-center">
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                        </svg>
                        Vous économisez
                      </span>
                      <span class="font-bold text-green-700">
                        {{ formatPrice(pkg.price - (pkg.promo_price || pkg.price)) }} XAF
                      </span>
                    </div>
                  </div>
                </div>

                <button
                  @click="selectPackage(pkg)"
                  class="w-full group cursor-pointer relative overflow-hidden bg-gradient-to-r from-primary-300 to-primary-600 hover:from-primary-700 hover:to-blue-700 text-white font-bold py-5 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/25"
                >
                  <div class="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                  <span class="relative flex items-center justify-center">
                    <svg class="w-5 h-5 mr-2 group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                    </svg>
                    Choisir {{ pkg.name }}
                  </span>
                </button>

                <div class="mt-6 space-y-2">
                  <div class="flex items-center text-gray-500 text-sm">
                    <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    Accès immédiat après paiement
                  </div>
                  <div class="flex items-center text-gray-500 text-sm">
                    <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    Support technique 24/7
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div v-else-if="!generalStore.isLoading" class="text-center py-20">
          <div class="max-w-md mx-auto flex justify-center flex-col">
            <div class="inline-flex items-center justify-center w-24 h-24 bg-gray-100 rounded-3xl mb-8">
              <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 7l-8-4-8 4m16 0l-8 4-8-4m16 0v10l-8 4-8-4V7"></path>
              </svg>
            </div>
            <h3 class="text-2xl font-bold text-gray-900 mb-4">Aucun forfait disponible</h3>
            <p class="text-gray-500 mb-8 leading-relaxed">
              Il semble qu'aucun forfait ne soit disponible pour l'examen sélectionné. Veuillez choisir un autre type d'examen ou réessayez plus tard.
            </p>
            <button
              @click="loadPackages"
              class="inline-flex cursor-pointer items-center px-8 py-4 bg-gradient-to-r from-purple-600 to-primary-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
              Recharger les forfaits
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useGeneralStore } from '@/stores/general'
import { useRouter } from 'vue-router'
import LoadingState from "@/components/exercices/LoadingState.vue";
import {useAuthStore} from "@/stores/auth.js";

const generalStore = useGeneralStore()
const authStore = useAuthStore()
const router = useRouter()


const promoCodeInput = ref('')
const error = ref('')
const examTypes = ref([])
const selectedExamType = ref(null)
const examtype_slug = ref(null)


const pageTitle = computed(() => {
  return selectedExamType.value ? selectedExamType.value.name : 'Nos Examens'
})

const pageDescription = computed(() => {
  if (selectedExamType.value) {
    return `Découvrez nos forfaits premium conçus pour maximiser vos chances de réussite au ${selectedExamType.value.name}.`
  }
  return 'Choisissez un type d\'examen pour découvrir nos offres sur mesure.'
})

const loadPackages = async () => {
  if (!selectedExamType.value) {
    generalStore.packages = [];
    return;
  }
  error.value = ''
  const result = await generalStore.fetchPackages(selectedExamType.value.slug, generalStore.codePromo)

  if (!result.success) {
    error.value = result.error || 'Erreur lors du chargement des forfaits.'
  }else{
    await router.replace('/packages?'+(selectedExamType.value?.slug ? 'examtype='+selectedExamType.value?.slug+'&' :'')+(generalStore.codePromo? 'codePromo='+generalStore.codePromo :''));
  }
}

const loadExamTypes = async () => {
  try {
    const types = await generalStore.fetchExamType()
    examTypes.value = types
    console.log(types)
    if (types && types.length > 0) {
      if(examtype_slug.value != null){
        selectedExamType.value = types.find((t) => t?.slug === examtype_slug.value )
      }
      if (!selectedExamType.value) selectedExamType.value = types[0]

      await loadPackages()
    } else {
      generalStore.isLoading = false;
    }


  } catch (e) {
    error.value = 'Impossible de charger les types d\'examen.'
    console.error('Erreur fetchExamType:', e)
    generalStore.isLoading = false;
  }
}


const handleExamTypeChange = async (exam) => {
  if (selectedExamType.value?.slug === exam.slug) return;

  selectedExamType.value = exam

  generalStore.codePromo = ''
  promoCodeInput.value = ''

  await loadPackages()
}


const applyPromoCode = async () => {
  if (!promoCodeInput.value.trim() || !selectedExamType.value) return

  error.value = ''
  generalStore.codePromo = promoCodeInput.value.trim()
  await loadPackages();
}


const formatPrice = (price) => {
  if (price === null || price === undefined) return '0,0'
  return new Intl.NumberFormat('fr-CM', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(price)
}


const selectPackage = (pkg) => {

  const button = event.currentTarget
  button.classList.add('animate-pulse')

  setTimeout(() => {
    button.classList.remove('animate-pulse')
  }, 300)

  if (authStore.isAuthenticated){
    router.push(`/buy-package/${pkg?.slug}${generalStore.codePromo ? '/'+generalStore.codePromo : ''}`)
  }else{
    router.push(`/login?redirect=/buy-package/${pkg?.slug}${generalStore.codePromo ? '/'+generalStore.codePromo : ''}`)
  }

}


onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)
  examtype_slug.value = urlParams.get('examtype');
  const promoCode = urlParams.get('codePromo');
  if (promoCode) {
    promoCodeInput.value = promoCode
    generalStore.codePromo = promoCodeInput.value.trim()
  }
  loadExamTypes()
})
</script>

<style scoped>
@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 0.8s ease-out forwards;
}

.package-card {
  animation: fade-in-up 0.6s ease-out forwards;
  opacity: 0;
}

.package-card:nth-child(1) { animation-delay: 0ms; }
.package-card:nth-child(2) { animation-delay: 100ms; }
.package-card:nth-child(3) { animation-delay: 200ms; }
.package-card:nth-child(4) { animation-delay: 300ms; }
.package-card:nth-child(5) { animation-delay: 400ms; }
.package-card:nth-child(6) { animation-delay: 500ms; }

.package-card:hover {
  box-shadow:
    0 0 50px rgba(168, 85, 247, 0.1),
    0 0 100px rgba(59, 130, 246, 0.1),
    0 20px 40px rgba(0, 0, 0, 0.1);
}

@keyframes gentle-bounce {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-5px) rotate(2deg); }
}

.package-card:hover svg {
  animation: gentle-bounce 2s ease-in-out infinite;
}
</style>
